/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfbstoryhint3Inputs */

const en_crosspostingfbstoryhint3 = /** @type {(inputs: Crosspostingfbstoryhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single image (1080×1920).`)
};

const de_crosspostingfbstoryhint3 = /** @type {(inputs: Crosspostingfbstoryhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein einzelnes Bild (1080×1920).`)
};

/**
* | output |
* | --- |
* | "A single image (1080×1920)." |
*
* @param {Crosspostingfbstoryhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfbstoryhint3 = /** @type {((inputs?: Crosspostingfbstoryhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfbstoryhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfbstoryhint3(inputs)
	return de_crosspostingfbstoryhint3(inputs)
});
export { crosspostingfbstoryhint3 as "crosspostingFbStoryHint" }